import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sl20',
  templateUrl: './sl20.component.html',
  styleUrls: ['./sl20.component.scss']
})
export class Sl20Component implements OnInit{

    @Input() dark: boolean=false;
    @Input({required: true}) package: any;

      constructor(
    private router: Router
  ) {

  }
  ngOnInit(): void {
    console.log(this.package)
  }

  protected buttonClick(link: string): void {
    this.router.navigate([link]);
  }

}
